<template>
  <div class="group" style="padding-left: 10px">
    <div class="contentNew">
      <ul class="quyetdinh">
            <li style="list-style: none">
          <a :href="currentLanguage.body_text_congty_Quydinhanninhmang2025driver"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Quydinhanninhmang2025 }}
            </span> 
          </a>
        </li>
            <li>
          <a target="_blank" :href="currentLanguage.body_text_congty_Quydinhnoiboquantriruroruatien2025driver">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_Quydinhnoiboquantriruroruatien2025

            }}
            </span>
          </a>
        </li>
        
          <li>
          <a target="_blank" :href="currentLanguage.body_text_congty_Quydinhnoibobaovedulieu2025driver">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_Quydinhnoibobaovedulieu2025
            }}
            </span>
          </a>
        </li>
      
       </ul> 
      
    </div>
  </div>
</template>
<script>
import { languages } from "@/components/languages";

export default {
  components: {},
  data() {
    return {
      currentLanguage: languages.vi,
      lang: "",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("languages") || "vi";
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },
  },
};
</script>